import React from "react";
import AccountLayout from "../layouts/AccountLayout/AccountLayout";
import ScreenDetailContainer from "../features/screenDetail/containers/ScreenDetailContainer";

const ScreenDetailView = (props) => {
  return (
    <AccountLayout>
      <ScreenDetailContainer {...props} />
    </AccountLayout>
  );
};

export default ScreenDetailView;
